export default __webpack_public_path__ + "dad78cc562b21a87029f5cfba744535e.png";